import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ContactForm from './ContactForm';

const { FiMail, FiMapPin, FiLinkedin, FiTwitter } = FiIcons;

const Footer = () => {
  return (
    <footer id="contact" className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-2">
            <div className="text-2xl font-bold text-blue-400 mb-4">
              HVAC Biz Broker
            </div>
            <p className="text-gray-300 mb-6 leading-relaxed max-w-md">
              Specializing in successful exits for HVAC and plumbing companies. We connect qualified buyers with business owners ready to transition.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <SafeIcon icon={FiLinkedin} className="w-6 h-6" />
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-400 transition-colors">
                <SafeIcon icon={FiTwitter} className="w-6 h-6" />
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-300">
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Sell-Side Advisory</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Buyer Matching</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Business Valuation</a></li>
              <li><a href="#services" className="hover:text-blue-400 transition-colors">Confidential Marketing</a></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <div className="space-y-3 text-gray-300">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="w-5 h-5 text-blue-400" />
                <a href="mailto:info@hvacbizbroker.com" className="hover:text-blue-400 transition-colors">
                  info@hvacbizbroker.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="w-5 h-5 text-blue-400" />
                <span>Nationwide Service</span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-1">
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ContactForm />
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2024 HVAC Biz Broker. All rights reserved. | Privacy Policy | Terms of Service</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;